import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveInactiveFor, GeneralConfigType, KeyValues5, LocalService, Status } from '../../../service/local.service';
import { FieldConfigComponent } from '../../popups/field-config/field-config.component';

@Component({
  selector: 'app-fields-config',
  templateUrl: './fields-config.component.html',
  styleUrls: ['./fields-config.component.scss']
})
export class FieldsConfigComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["table"];
  wrappers: KeyValues5[]; types: KeyValues5[]; countryId: string = '';
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private modalService: NgbModal, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.countryId = routeParams.countryId;
      this.onLoad();
    });
  }

  onLoad() {
    this.configurationManagementService.getConfigurations(GeneralConfigType.Fields, null).subscribe(result => {
      this.types = result.items;
      this.onGetCountry();
    });
  }

  onGetCountry() {
    this.configurationManagementService.getFields(this.countryId).subscribe(result => {
      this.wrappers = result;      
    });
  }

  getTypeName(id: string) {
    return this.types.find(x => x.key == id).v3;
  }

  openCreateEditPopup(id: string) {
    const modalRef = this.modalService.open(FieldConfigComponent, { ariaLabelledBy: 'modal-basic-title' });
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.countryId = this.countryId;
    modalRef.componentInstance.types = this.types;
  }

  onActiveInactiveStatus(strId: string) {
    this.configurationManagementService.activeInactiveStatus(strId, ActiveInactiveFor.Field).subscribe(result => {
      if (result == Status.Success) {
        const updatedItem = this.wrappers.find(x => x.key == strId);
        updatedItem.v2 = updatedItem.v2 == "1" ? "0" : "1";
      }      
    });
  }
}
